<template>
  <div class="not-found-container">
    <h1>404</h1>
    <h2>页面未找到</h2>
    <p>抱歉，您访问的页面不存在</p>
    <a-button type="primary" @click="$router.push('/')">
      回到首页
    </a-button>
  </div>
</template>

<script setup>
// No additional logic needed
</script>

<style scoped>
.not-found-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 60vh;
  text-align: center;
}

h1 {
  font-size: 72px;
  margin-bottom: 0;
  color: #1890ff;
}

h2 {
  font-size: 24px;
  margin-top: 10px;
  margin-bottom: 20px;
}

p {
  margin-bottom: 30px;
  color: #666;
}
</style> 